import classNames from "classnames"
import React from "react"

import { Title2 } from "@bounce/design-system"

import { HowItWorksStepsCompact } from "./HowItWorksCompactSteps"
import type StepCompact from "@/components/LuggageStorage/HowItWorks/HowItWorksCompact/types"
import { useSectionViewed } from "@/hooks/useSectionViewed"

export type HowItWorksCompactProps = {
  title: string
  className?: string
  steps: StepCompact[]
}

export const HowItWorksCompact = ({ steps, title, className }: HowItWorksCompactProps) => {
  const { sectionRef } = useSectionViewed({ name: "HowItWorksCompact" })

  return (
    <article ref={sectionRef} className={classNames("w-full max-w-screen-xl px-6", className)}>
      <Title2>{title}</Title2>
      <HowItWorksStepsCompact steps={steps} className="mt-8" />
    </article>
  )
}
